export const faqs = [
  {
    q: 'What is the Clear Aligner Clinical Blueprint™?',
    a: 'It is a digital educational collection consisting of six volumes and five bonuses designed to help dental professionals organize clear aligner case assessment, treatment-planning considerations, digital plan review, monitoring, and reassessment.',
  },
  {
    q: 'What exactly will I receive?',
    a: 'You will receive six digital volumes: Clear Aligner Case Assessment & Clinical Foundations; From Clinical Findings to Treatment Objectives; Clear Aligner Biomechanics & Movement Considerations; Treatment Sequencing & Digital Planning Review; Tracking, Refinement & Treatment Reassessment; and The Complete Clear Aligner Case Review Blueprint. You will also receive five bonuses: the Case Analysis Cards™, Case Mapping Workbook™, Biomechanics Review Checklist™, Troubleshooting Casebook™, and One-Page Case Review Template™.',
  },
  {
    q: 'Is this a physical product?',
    a: 'No. This offer is intended to provide digital educational materials. Check the checkout page for the exact file formats and delivery instructions.',
  },
  {
    q: 'How much does it cost?',
    a: 'The advertised offer price is $27 USD as a one-time payment. Confirm the final amount and any applicable taxes or currency conversion at checkout.',
  },
  {
    q: 'Is this a recurring subscription?',
    a: 'No recurring subscription is intended for this offer. It is presented as a one-time purchase. Please verify the payment terms displayed at checkout before completing your order.',
  },
  {
    q: 'Is this suitable for general dentists?',
    a: 'The materials are intended for dental professionals seeking an educational framework for organizing clear aligner case-review considerations. Individual suitability depends on professional training, scope of practice, and the applicable regulations in your location.',
  },
  {
    q: 'Is this suitable for orthodontists?',
    a: 'Orthodontists may use the materials as an educational reference for organizing case assessments, reviewing proposed treatment plans, and documenting relevant considerations. The resource does not replace specialized training or independent clinical judgment.',
  },
  {
    q: 'Does this resource provide patient-specific treatment instructions?',
    a: 'No. It provides general educational frameworks, worksheets, and review prompts. Treatment decisions must be based on individual patient assessment, appropriate diagnostic records, professional judgment, and applicable clinical guidance.',
  },
  {
    q: 'Will this guarantee better treatment outcomes?',
    a: 'No specific clinical outcome is guaranteed. The resource is designed to support organization and structured review, not to promise a particular treatment result.',
  },
  {
    q: 'Can I use the worksheets more than once?',
    a: 'The collection is designed as a reusable educational reference. Confirm the permitted usage and licensing terms provided with your purchase before reproducing or distributing any materials.',
  },
  {
    q: 'Do I need special software?',
    a: 'The collection is intended as a digital educational resource. Confirm the actual file formats and any software requirements listed at checkout before purchasing.',
  },
  {
    q: 'How do I access the materials?',
    a: 'Follow the digital delivery instructions provided after checkout.',
  },
  {
    q: 'Is there a refund policy?',
    a: 'Please review the refund terms displayed at checkout.',
  },
  {
    q: 'Is the blueprint a substitute for clinical training?',
    a: 'No. It is an educational reference intended to complement existing professional knowledge. It does not replace formal training, individualized diagnosis, clinical judgment, manufacturer instructions, or applicable regulations.',
  },
]
